<template>
  <div>
    <v-row>
      <v-col>
        Tot published articles: {{this.$store.getters.articles.filter(a=>a.state==="PUBLISHED").length}}
        <br />
        Tot articles: {{this.$store.getters.articles.length}}
        <br />
        Tot German published articles: {{this.$store.getters.articles.filter(a=>a.state==="PUBLISHED").filter(a=>a.lang==="de").length}}
        <br />
        Tot French published articles: {{this.$store.getters.articles.filter(a=>a.state==="PUBLISHED").filter(a=>a.lang==="fr").length}}
        <br />
        Tot Italian published articles: {{this.$store.getters.articles.filter(a=>a.state==="PUBLISHED").filter(a=>a.lang==="it").length}}
        <br />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <highcharts :options="openedByData"></highcharts>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { Chart } from "highcharts-vue";
export default {
  components: { highcharts: Chart },
  data() {
    return {
      openedBy: [],
      openedOnWeb: [],
      likes: [],
      openedByData: {},
      likesData: {}
    };
  },
  mounted() {
    this.loadStats();
  },
  methods: {
    mergeArrayObjectsById: function(arr1, arr2) {
      arr1.sort((a, b) => a.id - b.id);
      arr2.sort((a, b) => a.id - b.id);
      if (arr1.length > arr2.length) {
        return arr1.map(item => {
          if (arr2.find(o => o.id === item.id) !== undefined) {
            //merging two objects
            return Object.assign({}, item, arr2.find(o => o.id === item.id));
          } else {
            return item;
          }
        });
      } else {
        return arr2.map(item => {
          if (arr1.find(o => o.id === item.id) !== undefined) {
            //merging two objects
            return Object.assign({}, item, arr1.find(o => o.id === item.id));
          } else {
            return item;
          }
        });
      }
    },
    loadStats: function() {
      let merged = this.mergeArrayObjectsById(
        Object.values(this.$store.state.stats.stats),
        this.$store.getters.articles.filter(a => a.state === "PUBLISHED")
      );
      this.openedBy = [
        ...merged.sort(this.sortByPropertyArrayLength("openedBy"))
      ];
      this.openedOnWeb = [
        ...merged.sort(this.sortByPropertyArrayLength("openedOnWeb"))
      ];
      this.likes = [...merged.sort(this.sortByPropertyArrayLength("like"))];

      this.openedByData = {
        chart: {
          type: "column"
        },
        title: {
          text: "Article most read"
        },
        xAxis: {
          type: "category",
          labels: {
            rotation: -45,
            style: {
              fontSize: "13px",
              fontFamily: "Verdana, sans-serif"
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: "Tot"
          }
        },
        legend: {
          enabled: false
        },
        series: [
          {
            name: "Opened times",
            data: this.openedBy.map(o => [
              o.title,
              o.openedBy !== undefined ? o.openedBy.length : 0
            ])
          }
        ]
      };

      this.likesData = {
        chart: {
          type: "column"
        },
        title: {
          text: "Article likes"
        },
        xAxis: {
          type: "category",
          labels: {
            rotation: -45,
            style: {
              fontSize: "13px",
              fontFamily: "Verdana, sans-serif"
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: "Tot"
          }
        },
        legend: {
          enabled: false
        },
        series: [
          {
            name: "Likes",
            data: this.likes.map(o => [
              o.title,
              o.like !== undefined ? o.like.length : 0
            ])
          }
        ]
      };
    },
    sortByPropertyArrayLength: function(property) {
      return (b, a) => {
        if (a[property] !== undefined && b[property] === undefined) {
          return 1;
        } else if (a[property] === undefined && b[property] !== undefined) {
          return -1;
        } else if (a[property] === undefined && b[property] === undefined) {
          return 0;
        }
        return a[property].length > b[property].length
          ? 1
          : a[property].length < b[property].length
          ? -1
          : 0;
      };
    }
  }
};
</script>
